// npm
import React from 'react'

export default function Image() {
  return <p>Image Page</p>
}
